<template>
  <div>
    <template v-if="loading">
      <content-placeholders>
        <content-placeholders-text :lines="5" />
      </content-placeholders>
    </template>
    <template v-else>
      <div class="catalog-view__activity" v-if="hierarchy">
        <div class="catalog-view__activity-head">
          <div class="catalog-view__subtitle catalog-view__subtitle-activity" id="hierarchy">Продуктовая иерархия (активити)</div>
          <a class="catalog-view__link catalog-view__link--lg" href="/product-file">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 15L18 6L9 6L9 8L16 8L16 15L18 15Z" fill="#00AC86" />
              <path d="M17 7L6 18" stroke="#00AC86" stroke-width="2" />
            </svg>
            <span>Выгрузка по активити</span>
          </a>
        </div>
        <div class="catalog-view__table catalog-view__table-activity">
          <table>
            <thead>
            <tr>
              <th>COS1</th>
              <th>Описание COS1</th>
              <th>COS2</th>
              <th>Описание COS2</th>
              <th>COS3</th>
              <th>Описание COS3</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td data-text="COS1">
                <a class="catalog-view__link" href="#">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 15L18 6L9 6L9 8L16 8L16 15L18 15Z" fill="#00AC86" />
                    <path d="M17 7L6 18" stroke="#00AC86" stroke-width="2" />
                  </svg>
                  <span> {{ hierarchy.cos1 }}</span>
                </a>
              </td>
              <td>{{ hierarchy.collection }}</td>
              <td data-text="COS2">
                <a class="catalog-view__link" href="#" v-if="hierarchy.cos2">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 15L18 6L9 6L9 8L16 8L16 15L18 15Z" fill="#00AC86" />
                    <path d="M17 7L6 18" stroke="#00AC86" stroke-width="2" />
                  </svg>
                  <span>{{ hierarchy.cos2 }}</span>
                </a>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="hierarchy.line">{{ hierarchy.line }}</span>
                <span v-else>-</span>
              </td>
              <td data-text="COS3">
                <a class="catalog-view__link" href="#" v-if="hierarchy.cos3">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 15L18 6L9 6L9 8L16 8L16 15L18 15Z" fill="#00AC86" />
                    <path d="M17 7L6 18" stroke="#00AC86" stroke-width="2" />
                  </svg>
                  <span>{{ hierarchy.cos3 }}</span>
                </a>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="hierarchy.subline">{{ hierarchy.subline }}</span>
                <span v-else>-</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="catalog-view__activity-mobile" v-if="hierarchy">
        <div class="catalog-view__subtitle">Продуктовая иерархия</div>
        <div class="catalog-view__activity-rows">
          <div class="catalog-view__activity-row">
            <div class="catalog-view__activity-item">COS1</div>
            <div class="catalog-view__activity-item">
              <a class="catalog-view__link" href="#">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 15L18 6L9 6L9 8L16 8L16 15L18 15Z" fill="#00AC86" />
                  <path d="M17 7L6 18" stroke="#00AC86" stroke-width="2" />
                </svg>
                <span>{{ hierarchy.cos1 }}</span>
              </a>
            </div>
            <div class="catalog-view__activity-item">{{ hierarchy.collection }}</div>
          </div>
          <div class="catalog-view__activity-row" v-if="hierarchy.cos2">
            <div class="catalog-view__activity-dot"></div>
            <div class="catalog-view__activity-item">COS2</div>
            <div class="catalog-view__activity-item">
              <a class="catalog-view__link" href="#">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 15L18 6L9 6L9 8L16 8L16 15L18 15Z" fill="#00AC86" />
                  <path d="M17 7L6 18" stroke="#00AC86" stroke-width="2" />
                </svg>
                <span>{{ hierarchy.cos2 }}</span>
              </a>
            </div>
            <div class="catalog-view__activity-item">{{ hierarchy.line }}</div>
          </div>
          <div class="catalog-view__activity-row" v-if="hierarchy.cos3">
            <div class="catalog-view__activity-dot"></div>
            <div class="catalog-view__activity-dot"></div>
            <div class="catalog-view__activity-item">COS3</div>
            <div class="catalog-view__activity-item">
              <a class="catalog-view__link" href="#">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 15L18 6L9 6L9 8L16 8L16 15L18 15Z" fill="#00AC86" />
                  <path d="M17 7L6 18" stroke="#00AC86" stroke-width="2" />
                </svg>
                <span>{{ hierarchy.cos3 }}</span>
              </a>
            </div>
            <div class="catalog-view__activity-item">{{ hierarchy.subline }}</div>
          </div>
        </div>
      </div>
    </template>

  </div>
</template>

<script>

import {EVENT_ADD_CHIPS} from "../../views/ProductCard";

export default {
  name: 'product-hierarchy',
  components: {
  },
  props: {
    product_id: {
      require: true
    }
  },
  data: () => ({
    hierarchy: null,
    loading: true
  }),
  created() {
    this.$api.product.hierarchy(this.product_id).then((response) => {
      if (response && response.data) {
        this.hierarchy = response.data
        if (this.hierarchy) {
          this.$emit(EVENT_ADD_CHIPS, {
            link: 'hierarchy',
            title: 'Продуктовая иерархия',
            size: null,
            order: 1
          })
        }
      }
      this.loading = false
    }).catch(() => {
      this.loading = false
    })
  },
  methods: {

  }
}
</script>